import moment from "moment";

//Costruisci il model basato su questi campi
export class Evento {
  id: number | null;
  title: string | null;
  startDate: string | null;
  endDate: string | null;
  department: string | null;
  color: string | null;
  description: string | null;
  location: string | null;
  place: string | null;
  allDay: number | null;
  dataInizio: string | null;
  dataFine: string | null;
  medico: {
    id: number | null;
    firstname: string | null;
    lastname: string | null;
    email: string | null;
    phone: string | null;
    address: string | null;
    specializzazione: string | null;
  } 

  constructor(data: any = {}) {
    this.id = data.id != null ? Number(data.id) : null;
    this.title = data.title ?? null;
    this.startDate = data.startDate ?? null;
    this.endDate = data.endDate ?? null;
    this.department = data.department ?? null;
    this.color = data.color ?? null;
    this.description = data.description ?? null;
    this.location = data.location ?? null;
    this.place = data.place ?? null;
    this.allDay = data.allDay != null ? Number(data.allDay) : null;
    this.dataInizio = data.startDate != null ? moment(data.startDate).format("DD MMMM YYYY") : null;
    this.dataFine = data.endDate != null ? moment(data.endDate).format("DD MMMM YYYY") : null;  
    this.medico = {
      id: data.medico?.id != null ? Number(data.medico?.id) : null,
      firstname: data.medico?.firstname ?? null,
      lastname: data.medico?.lastname ?? null,
      email: data.medico?.email ?? null,
      phone: data.medico?.phone ?? null,
      address: data.medico?.address ?? null,
      specializzazione: data.medico?.specializzazione ?? null,
    };
  }
}

export default Evento;